import { ListFilter, SquareKanban } from "lucide-react";

const CoursePageSkills=({coursePageObject}) =>{
    return(<>
     <div style={{marginTop:"30px",borderRadius:"15px",padding:"10px",paddingBottom:"40px",background:`${coursePageObject?.skills?.bgColor?.color}`,
    border:` ${coursePageObject?.skills?.border?.borderWidth?.value+coursePageObject?.skills?.border?.borderWidth?.resolution} ${coursePageObject?.skills?.border?.borderType}  ${coursePageObject?.skills?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.skills?.borderRadius?.topLeft?.value}${coursePageObject?.skills?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.skills?.borderRadius?.topRight?.value}${coursePageObject?.skills?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.skills?.borderRadius?.bottomLeft?.value}${coursePageObject?.skills?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.skills?.borderRadius?.bottomRight?.value}${coursePageObject?.skills?.borderRadius?.bottomRight?.resolution}`,
}} >
    <div className="themeCoursePage grid2080CoursePage"  style={{
    borderRadius:"25px",margin:"3px"}}>
    <div style={{background:`${coursePageObject?.skills?.iconBgColor?.color}`,width:"56px",height:"56px",borderRadius:"50%",padding:"0px",display:"flex",justifyContent:"center",alignItems:"center"}} >
    <SquareKanban strokeWidth={4} absoluteStrokeWidth  size={30} style={{margin:"8px",marginTop:"10px"}} color={coursePageObject?.skills?.icon2Color?.color} />  </div>
    <div   >
    </div></div>
  <div><div   >
      <div className="themeCoursePage coursePageTitleFont"   style={{margin:"0px",fontSize:"32px",fontWeight:"800",color:coursePageObject?.skills?.textColor?.color}}>
        Skills </div>  
   
<div className=" gridForCoursePageFiftyFifty"  style={{marginTop:"10px",overflow:"hidden",
    minHeight:"190px",position:"relative"}}>

      <div  className="courseWhatWillearnIcon"style={{background:coursePageObject?.skills?.icon2BgColor?.color,margin:"10px",marginTop:"20px",padding:"10px",borderRadius:"15px"}}>
      <ListFilter strokeWidth={3} absoluteStrokeWidth  size={23}  color={coursePageObject?.skills?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont "
 style={{fontSize:"14px",color:coursePageObject?.skills?.subTextColor?.color,fontWeight:"500"}}> 
   This Course Includes Hands On Exercises Videos And Tests To Equip You With All Inportant Trends In Blender
 
      </div>
      </div><div  className="courseWhatWillearnIcon"style={{background:coursePageObject?.skills?.icon2BgColor?.color,margin:"10px",marginTop:"20px",padding:"10px",borderRadius:"15px"}}>
      <ListFilter strokeWidth={3} absoluteStrokeWidth  size={23}  color={coursePageObject?.skills?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont"
 style={{fontSize:"14px",color:coursePageObject?.skills?.subTextColor?.color,fontWeight:"500"}}> 
  This Course Includes Hands On Exercises Videos And Tests 
      </div>
      </div><div  className="courseWhatWillearnIcon"style={{background:coursePageObject?.skills?.icon2BgColor?.color,margin:"10px",marginTop:"20px",padding:"10px",borderRadius:"15px"}}>
      <ListFilter strokeWidth={3} absoluteStrokeWidth  size={23}  color={coursePageObject?.skills?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont"
 style={{fontSize:"14px",color:coursePageObject?.skills?.subTextColor?.color,fontWeight:"500"}}> 
  This Course Will Equip You With All Inportant Trends In Blender
      </div>
</div>


  
    </div> 
   
    </div>
    
  
      </div>
    </div></>)
}
export default CoursePageSkills;